<!--
 * @Author: Lemon C
 * @Date: 2024-12-10 17:39:52
 * @LastEditTime: 2025-01-13 15:22:18
-->
<template>
    <div class="sup-product-course-comp">
        <div class="re-w1200 re-main-col">
            <div class="type-title-box">
                <div class="title-blue-line"></div>
                <span class="title">开发指南</span>
                <img src="@/assets/imgs/devDoc/more_btn.png" @click="jump_devGuide_click" />
            </div>
            <div class="grid-list-box">
                <div
                    class="grid-item-box"
                    v-for="(item, index) in product_guide_list"
                    :key="`item_${index}`"
                    @click="jump_devGuide_item_click(item)">
                    <div class="item-top-box">
                        <div class="item-img">
                            <img :src="downloadBaseUrl_computed(item.accessory)" />
                        </div>
                        <span class="item-title">{{ item.title }}</span>
                    </div>
                    <span class="item-dis">{{ item.description }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

const props = defineProps({
    product_guide_list: {
        type: Array,
        default: () => [],
    },
});

const downloadBaseUrl_computed = computed(() => (path) => {
    let url = '';
    if (path && path.length) {
        url = `${window.downloadBaseUrl}/${path}`;
    }
    return url;
});

// MARK Click  跳转开发指南
const jump_devGuide_click = () => {
    router_store.navigateToGuide();
};

// MARK Click Item  跳转开发教程
const jump_devGuide_item_click = (item) => {
    router_store.navigateToGuide({ shareType: 1, treeId: item.dcId });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-product-course-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .type-title-box {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;

        .title-blue-line {
            position: relative;
            width: 6px;
            height: 48px;
            border-radius: 1px;
            background: var(--color-main-brand);
        }

        .title {
            position: relative;
            margin-left: 20px;
            height: 48px;
            flex: 1;
            font-weight: 400;
            font-size: 32px;
            color: var(--color-main-text-primary);
        }

        img {
            position: relative;
            margin-right: 0;
            width: 36px;
            height: 36px;
            cursor: pointer;
            border-radius: 18px;
            outline: 0 solid transparent;
            transition: var(--animation-outline-style);

            &:hover {
                outline: 4px solid var(--color-main-outline-hover);
            }
        }
    }

    .grid-list-box {
        position: relative;
        width: 100%;
        margin-top: 47px;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 60px;
        row-gap: 40px;

        .grid-item-box {
            position: relative;
            display: flex;
            height: 193px;
            padding: 35px 27px;
            box-sizing: border-box;
            border-radius: 10px;
            cursor: pointer;
            flex-direction: column;
            background-color: var(--color-main-light-bg-white);
            box-shadow: var(--color-main-card-shadow-small);
            border: 2px solid var(--color-main-transparent-bg);
            transition: var(--animation-border-style);

            .item-top-box {
                position: relative;
                display: flex;
                align-items: center;
                height: 40px;

                .item-img {
                    position: relative;
                    width: 28px;
                    height: 28px;
                    // border-radius: 14px;
                    // border: 1px solid var(--color-main-brand);
                    // overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // box-shadow: var(--color-main-dev-center-course-shadow);

                    img {
                        position: relative;
                        width: 24px;
                        height: 24px;
                        border-radius: 12px;
                    }
                }

                .item-title {
                    position: relative;
                    height: 30px;
                    margin-left: 10px;
                    font-weight: 400;
                    font-size: 20px;
                    color: var(--color-main-text-primary);
                }
            }

            .item-dis {
                position: relative;
                margin-top: 21px;
                display: flex;
                flex: 1;
                font-size: 13px;
                line-height: 16px;
                color: var(--color-main-text-secondary);
            }

            &:hover {
                border: 2px solid var(--color-main-brand-hover);
            }
        }
    }
}
</style>
